import Alert from './Alert';
import './Alert.scss';
export default Alert;
